import React, { useState } from 'react';
import { submitIssue } from '../api';

interface Props {
  confidence: 'HIGH' | 'MEDIUM' | 'LOW' | 'INSUFFICIENT';
  reason?: string;
  queryId?: string;
  queryText?: string;
  responseText?: string;
}

const BADGE_CONFIG: Record<string, { label: string; icon: string; className: string }> = {
  HIGH:         { label: 'High confidence',    icon: '✓', className: 'confidence-badge--high' },
  MEDIUM:       { label: 'Medium confidence',  icon: '–', className: 'confidence-badge--medium' },
  LOW:          { label: 'Low confidence',     icon: '⚠', className: 'confidence-badge--low' },
  INSUFFICIENT: { label: 'Insufficient data',  icon: '✕', className: 'confidence-badge--insufficient' },
};

export default function ConfidenceBadge({ confidence, reason, queryId, queryText, responseText }: Props) {
  const config = BADGE_CONFIG[confidence];
  const [feedbackSent, setFeedbackSent] = useState(false);
  const [sending, setSending] = useState(false);
  if (!config) return null;

  const handleFeedback = async () => {
    if (sending || feedbackSent) return;
    setSending(true);
    try {
      await submitIssue({
        category: 'wrong_answer',
        severity: confidence === 'LOW' || confidence === 'INSUFFICIENT' ? 'important' : 'minor',
        description: [
          `[Confidence Flag Feedback]`,
          `Confidence: ${confidence}`,
          `Reason: ${reason || 'N/A'}`,
          `Query: ${queryText || 'N/A'}`,
          `---`,
          `Full response included for review.`,
        ].join('\n'),
        query_id: queryId,
        query_text: queryText,
        response_text: responseText?.slice(0, 5000),
      });
      setFeedbackSent(true);
    } catch {
      // silent fail
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="confidence-block">
      <div className={`confidence-badge ${config.className}`}>
        <span className="confidence-badge-icon" aria-hidden="true">{config.icon}</span>
        <span className="confidence-badge-label">{config.label}</span>
      </div>
      {reason && (
        <p className="confidence-reason">{reason}</p>
      )}
      <button
        className="confidence-feedback-btn"
        onClick={handleFeedback}
        disabled={sending || feedbackSent}
      >
        {feedbackSent ? '✓ Feedback logged' : sending ? 'Submitting…' : 'Flag for review →'}
      </button>
    </div>
  );
}
